module.exports = __webpack_public_path__ + "static/smoke-c9d1f6a453d673a310bca758afcf73ac.png";